export default __webpack_public_path__ + "static/gallery10-9f0c15079fb9d4b276cf693b0a6495d3.png";